import type { JSX } from "preact";

function Dot(
  {
    index,
    class: _class,
    children,
  }: JSX.IntrinsicElements["button"] & { index: number },
) {
  return (
    <button
      data-dot={index}
      aria-label={`go to slider item ${index}`}
      class={`focus:outline-none group ${_class}`}
    >
      {children}
    </button>
  );
}

function Item({
  index,
  ...props
}: JSX.IntrinsicElements["li"] & { index: number }) {
  return <li data-slider-item={index} {...props} />;
}

function NextButton(props: JSX.IntrinsicElements["button"]) {
  return <button data-slide="next" aria-label="Next item" {...props} />;
}

function PrevButton(props: JSX.IntrinsicElements["button"]) {
  return <button data-slide="prev" aria-label="Previous item" {...props} />;
}

function ProgressBar() {
  return (
    <div
      data-slider-progress-bar
      class="w-full sm:max-w-xs h-1 mx-auto overflow-y-visible relative"
    >
      <div class="w-full h-0.5 bg-tw-base-100 absolute top-1/2 left-0 right-0 -translate-y-1/2" />

      <div
        id="thumb"
        class="w-16 h-1 bg-tw-primary-100 absolute left-0 top-0"
      />
    </div>
  );
}

function Slider(props: JSX.IntrinsicElements["ul"]) {
  return <ul data-slider {...props} />;
}

Slider.Dot = Dot;
Slider.Item = Item;
Slider.NextButton = NextButton;
Slider.PrevButton = PrevButton;
Slider.ProgressBar = ProgressBar;

export default Slider;
